/**
 * MCx Waitlist Modal — opener dispatcher for [data-mcx-waitlist-dialog].
 *
 * Triggers: any element with `data-mcx-waitlist-open="<line-handle>"`.
 *           The dialog id is `mcx-waitlist-dialog-<line-handle>`.
 *
 * Close behaviour, body scroll-lock, first-field focus, focus-return,
 * backdrop click, ESC, and Google Places typeahead are ALL handled by
 * `initDialog()` in assets/maker-waitlist.js — that function matches
 * `[data-mcx-waitlist-dialog]` too. This file just resolves the handle
 * → dialog and calls the wired `__openWaitlist` hook with the originating
 * trigger so focus can return to it on close.
 *
 * Form submission is handled by maker-waitlist.js, which binds to any
 * form carrying `[data-maker-waitlist]` (selector is shared across
 * maker + MCx).
 */
(function () {
  if (typeof document === 'undefined') return;

  function openWaitlist(handle, trigger) {
    if (!handle) return;
    var dialog = document.getElementById('mcx-waitlist-dialog-' + handle);
    if (!dialog) return;
    if (typeof dialog.__openWaitlist === 'function') {
      dialog.__openWaitlist(trigger || null);
      return;
    }
    // Fallback for the brief window before initDialog has run (e.g. a
    // very early click). Skip scroll-lock / focus wiring here; the next
    // page-load will pick up the dialog via DOMContentLoaded.
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-mcx-waitlist-open]');
    if (!opener) return;
    event.preventDefault();
    openWaitlist(opener.getAttribute('data-mcx-waitlist-open'), opener);
  });
})();
